import { asScaled } from '../utils';
const floatingButtonLayout = {
    buttonHeight: {
        large: 44,
        small: 36
    },
    buttonWidth: {
        large: 44,
        small: 36
    },
    iconSize: {
        large: 18,
        small: 16
    },
    titleSize: {
        large: 11,
        small: 10
    }
};
const floatingButtonLayoutScaled = asScaled(floatingButtonLayout);
export const floatingButton = {
    scaled: floatingButtonLayoutScaled,
    unscaled: floatingButtonLayout
};
